import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {HttpClient} from '@angular/common/http';
import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {debounceTime, finalize, switchMap, tap} from 'rxjs/operators';
import {SenderInfo} from '../../../models/SenderInfo';
import {CommonService} from '../../../services/common.service';
import {ExcelService} from '../../../services/excel.service';
import {MessageService} from '../../../services/message.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-report-reminder-dialog',
    templateUrl: './report-reminder-dialog.component.html',
    styleUrls: ['./report-reminder-dialog.component.scss']
})
export class ReportReminderDialogComponent implements OnInit {
    //#region members
    @ViewChild('emailInput', {static: false}) emailInput: ElementRef;
    addOnBlur = true;
    departmentEmails: any;
    editorStyle: any;
    emails: any[] = [];
    emailsCtrl = new FormControl();
    errorMsg: string;
    filteredEmails: Observable<any[]>;
    filteredUsers: any;
    htmlContent: any;
    incomingUserInfo: any;
    isLoading = false;
    mode: number; // 0: reportConsents, 1: reportAffirmations 2: SimpleEmail, 3:ReportDetails 4: parent message
    notificationMode: number;
    recipientsGroup = [];
    removable = true;
    selectable = true;
    selectedRecipientGroup: any;
    separatorKeysCodes = [ENTER, COMMA];
    subject: any;
    loading: boolean;
    parent: any;
    uniqueId: string;
    textContent: string;
    senders: SenderInfo[] = [];
    sender: SenderInfo;
    isRequestLoading: boolean;
    bothParents: boolean;
    removedEmails = [];

    //#endregion
    constructor(private commonService: CommonService,
                private http: HttpClient,
                public dialog: MatDialog,
                public excelService: ExcelService,
                private messageService: MessageService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<ReportReminderDialogComponent>,
                public toastMessagesService: ToastMessagesService) {
        this.editorStyle = {height: '350px', width: '100%'};
        this.notificationMode = 4;
        this.mode = data.mode;
        this.loading = false;
        this.textContent = '';
        this.uniqueId = data.uniqueId;
        this.isRequestLoading = false;
        this.bothParents = false;
        if (data.emails) {
            this.incomingUserInfo = data.emails;
            console.log(data.emails);
        }

        this.recipientsGroup = [{
            id: 1,
            label: 'Αποδέχτηκαν'
        },
            {
                id: 2,
                label: 'Σε αναμονή'
            }];
    }

    isButtonDisabled(): boolean {
        if (this.sender && this.htmlContent && this.subject && this.emails.length > 0 && !this.isRequestLoading) {
            return false;
        } else {
            return true;
        }
    }

    async ngOnInit() {
        await this.initSenders();
        this.emailsCtrl.valueChanges
            .pipe(
                debounceTime(500),
                tap(() => {
                    this.errorMsg = '';
                    this.filteredUsers = [];
                    this.isLoading = true;
                }),
                switchMap(value => this.http.post('people/userByEmail', {param: value})
                    .pipe(
                        finalize(() => {
                            this.isLoading = false;
                        }),
                    )
                )
            )
            .subscribe(data => {
                if (data) {
                    this.filteredUsers = data;
                }
            });
    }

    async initSenders() {
        try {
            const request = await this.commonService.getList('college/email-senders');
            this.senders = request.object;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e);
            throw e;
        }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        const model = {
            label: event.option.viewValue,
            displayName: `${event.option.value.firstName} ${event.option.value.lastName}`,
            email: event.option.value.email[0],
            phone: event.option.value.telephone
        };
        this.emails.push(model);
        this.emailInput.nativeElement.value = '';
        this.emailsCtrl.setValue(null);
    }

    removeEmail(email: any) {
        const index = this.emails.indexOf(email);

        if (index >= 0) {
            this.removedEmails.push(this.emails[index]);
            this.emails.splice(index, 1);
        }
    }

    addEmail($event: any) {
        // @ts-ignore
        const input = event.input;
        // @ts-ignore
        const value = event.value;

        // Add email
        if ((value || '').trim()) {
            this.emails.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }

        this.emailsCtrl.setValue(null);
    }

    filter(name: string) {
        try {
            if (name) {
                return this.departmentEmails.filter(email =>
                    email.email.toLowerCase().indexOf(name.toLowerCase()) === 0);
            }
        } catch (e) {

        }
    }

    displayFn(user: any): string {
        return user && user.first_name ? user.first_name : '';
    }

    close() {
        this.dialogRef.close();
    }

    async sendMessage() {

        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Αποστολή ενημέρωσης',
                message: this.bothParents ? `Είστε σίγουροι ότι θέλετε να στείλετε την ενημέρωση στους ${this.emails.length} επιλεγμένους χρήστες αλλά και στους χρήστες που δεν έχουν την επιμέλεια?` : `Είστε σίγουροι ότι θέλετε να στείλετε την ενημέρωση στους ${this.emails.length} επιλεγμένους χρήστες?`
            }
        });

        confirmDialog.afterClosed().subscribe(async (result) => {
            if (result) {
                try {
                    this.isRequestLoading = true;
                    const model = {
                        to: this.emails,
                        subject: this.subject,
                        messageHtml: this.htmlContent,
                        messageText: this.textContent,
                        uniqueId: this.uniqueId,
                        sender: this.sender,
                        state: this.selectedRecipientGroup ? this.selectedRecipientGroup.id : null,
                        bothParents: this.bothParents,
                        removedEmails: this.removedEmails
                    };
                    await this.messageService.sendReminder(model);
                    this.toastMessagesService.toastMessages('Οι ειδοποιήσεις στάλθηκαν με επιτυχία');
                    this.close();
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να στείλουμε τις ειδοποιήσεις');
                } finally {
                    this.isRequestLoading = false;
                }
            }
        });
    }

    async groupChange() {
        try {
            this.isLoading = true;

            if (+this.mode === 10) {
                this.initParentEmails();
            } else {
                this.initChildEmails();
            }


        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    }


    initParentEmails() {
        switch (this.selectedRecipientGroup.id) {
            case 1:
                this.emails = [];
                console.log('completed info');
                console.log(this.incomingUserInfo.completed);
                for (const record of this.incomingUserInfo.completed) {
                    const model = {
                        parent_first_name: record.first_name,
                        parent_id: record.parent_id,
                        parent_last_name: record.last_name,
                        label: record.first_name,
                        displayName: `${record.first_name} ${record.last_name}`,
                        email: record.email,
                        phone: record.telephone,
                    };
                    this.emails.push(model);
                }

                break;
            case 2:
                this.emails = [];
                console.log('pending info');
                console.log(this.incomingUserInfo.pending);
                for (const record of this.incomingUserInfo.pending) {
                    const model = {
                        parent_first_name: record.first_name,
                        parent_id: record.parent_id,
                        parent_last_name: record.last_name,
                        label: record.first_name,
                        displayName: `${record.first_name} ${record.last_name}`,
                        email: record.email,
                        phone: record.telephone,
                    };
                    this.emails.push(model);
                }
                break;
        }
    }

    initChildEmails() {
        switch (this.selectedRecipientGroup.id) {
            case 1:
                this.emails = [];
                console.log('completed info');
                console.log(this.incomingUserInfo.completed);
                for (const record of this.incomingUserInfo.completed) {
                    for (const parent of record.notificationTo) {
                        const model = {
                            child_id: record.child_id,
                            child_first_name: record.child_first_name,
                            child_last_name: record.child_last_name,
                            parent_first_name: parent.first_name,
                            parent_id: parent.id,
                            parent_last_name: parent.last_name,
                            label: parent.first_name,
                            displayName: `${parent.first_name} ${parent.last_name}`,
                            email: parent.parent_email,
                            phone: parent.parent_telephone,
                            notification_providers: parent.notification_providers
                        };
                        this.emails.push(model);
                    }
                }
                break;
            case 2:
                this.emails = [];
                console.log('pending info');
                console.log(this.incomingUserInfo.pending);
                for (const record of this.incomingUserInfo.pending) {
                    for (const parent of record.notificationTo) {
                        const model = {
                            child_id: record.child_id,
                            child_first_name: record.child_first_name,
                            child_last_name: record.child_last_name,
                            parent_first_name: parent.first_name,
                            parent_id: parent.id,
                            parent_last_name: parent.last_name,
                            label: parent.first_name,
                            displayName: `${parent.first_name} ${parent.last_name}`,
                            email: parent.parent_email,
                            phone: parent.parent_telephone,
                            notification_providers: parent.notification_providers
                        };
                        this.emails.push(model);
                    }
                }
                // for (let i = 0; i < 250; i++) {
                //     this.emails.push(this.emails[0]);
                // }
                break;
        }
    }

    exportToExcel() {
        const {records, columns} = this.formatModel();
        const date = new Date().toLocaleDateString();
        const fileName = this.selectedRecipientGroup.id === 1 ? `Χρήστες που αποδέχτηκαν - ${date}` : `Χρήστες σε αναμονή - ${date}`;
        this.excelService.exportAsCustomExcelFile(records, fileName, columns);
    }

    //#region helper methods
    formatModel() {
        const records = [];
        for (const record of this.emails) {
            const model = {
                child_first_name: record.child_first_name,
                child_last_name: record.child_last_name,
                parent_first_name: record.parent_first_name,
                parent_last_name: record.parent_last_name,
                email: record.email,
                phone: record.phone
            };
            records.push(model);
        }

        const columns = [{
            key: 'parent_first_name',
            label: 'Όνομα',
        },
            {
                key: 'parent_last_name',
                label: 'Επώνυμο',
            },
            {
                key: 'email',
                label: 'Εmail',
            },
            {
                key: 'phone',
                label: ' Τηλέφωνο',
            }, {
                key: 'child_first_name',
                label: 'Όνομα παιδιού',
            }, {
                key: 'child_last_name',
                label: 'Επώνυμο παιδιού',
            },
        ];

        return {records, columns};
    }

    transform(text: string): any {
        const plainText = text.replace(/<(?:.|\n)*?>/gm, ' ');
        return plainText.trim();
    }

    plainTextLength() {
        const plainText = this.htmlContent ? this.htmlContent.replace(/<(?:.|\n)*?>/gm, ' ') : '';
        return plainText.trim().length;
    }

    //#endregion
  updateMessage($event: any) {
    this.htmlContent = $event;
  }
}
